import { render } from "./personalFibre.vue?vue&type=template&id=07f49194&scoped=true"
import script from "./personalFibre.vue?vue&type=script&lang=js"
export * from "./personalFibre.vue?vue&type=script&lang=js"

import "./personalFibre.vue?vue&type=style&index=0&id=07f49194&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f49194"]])

export default __exports__